import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

import {
  IContactEmail,
  IContactNumber,
  MultiFieldData,
  ShareToCustomerPopupResponse,
} from '@shared/interfaces';
import { emailValidator } from '@shared/utils';

import { IBrokerDocumentUploaderPopup } from '../upload-document/upload-document.component';
export interface ShareDocumentData extends IBrokerDocumentUploaderPopup {
  shareTo: [
    {
      identityId: string;
      contactEmail: IContactEmail[];
      contactPhone: IContactNumber[];
    }
  ];
}

@Component({
  selector: 'app-share-document',
  templateUrl: './share-document.component.html',
  styleUrls: ['./share-document.component.scss'],
})
export class ShareDocumentComponent {
  files: File[] = [];
  addedEmails: string[] = [];
  separatorKeyCodes: number[] = [ENTER, COMMA]; // Allow Enter and Comma to separate emails
  emailValidationError = false;

  isLoading = false;

  shareFormGroup = new FormGroup({
    additionalEmail: new FormControl(null, [emailValidator()]),
    remarks: new FormControl(null),
  });

  contactDetails: {
    isSelect: boolean;
    details: MultiFieldData;
  }[] = [];

  constructor(
    public translate: TranslateService,
    private dialogRef: MatDialogRef<ShareDocumentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ShareDocumentData
  ) {
    this.contactDetails = data.shareTo.reduce((acc, item) => {
      if (item?.contactEmail.length > 0) {
        acc.push({
          isSelect: false,
          details: {
            type: 'EMAIL',
            value: item.contactEmail,
          },
        });
      }

      if (item?.contactPhone.length > 0) {
        acc.push({
          isSelect: false,
          details: {
            type: 'PHONE',
            value: item.contactPhone,
          },
        });
      }
      return acc;
    }, []);
  }

  checkDisability(): boolean {
    if (this.contactDetails.some((contact) => contact.isSelect)) {
      return false;
    } else {
      return true;
    }
  }

  addEmail(email: string): void {
    this.emailValidationError = false; // Reset error state
    email = email.trim();

    if (email && this.isValidEmail(email)) {
      if (!this.addedEmails.includes(email)) {
        this.addedEmails.push(email); // Add unique, valid email
      }
    } else if (email) {
      this.emailValidationError = true; // Set error if invalid email
    }
  }

  isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  removeEmail(email: string): void {
    const index = this.addedEmails.indexOf(email);
    if (index >= 0) {
      this.addedEmails.splice(index, 1);
    }
  }

  onClickShare() {
    if (!this.checkDisability()) {
      const selectedList = this.contactDetails
        .filter((contact) => contact.isSelect)
        .map((_contact) => _contact.details);

      const outputData: ShareToCustomerPopupResponse = {
        additionalEmail: this.shareFormGroup.controls.additionalEmail.value,
        remarks: this.shareFormGroup.controls.remarks.value,
        selectedList,
      };
      this.dialogRef.close(outputData);
    }
  }

  update(completed: boolean, index?: number) {
    this.contactDetails[index].isSelect = completed;
  }

  onClickCancel() {
    this.dialogRef.close();
  }
}
